// Search helpers for FilterModal. Kept free of React so they can be unit tested.

// Lists with more options than this get a search box automatically
// (unless the caller overrides it with the `searchable` prop).
export const FILTER_MODAL_SEARCH_MIN_OPTIONS = 8;

/** Whether the modal should render its search box. */
export function shouldShowFilterSearch(searchable, optionCount) {
  if (typeof searchable === 'boolean') return searchable;
  return optionCount > FILTER_MODAL_SEARCH_MIN_OPTIONS;
}

/**
 * "%word%" search: keeps options whose display label contains the query,
 * case-insensitively. A blank query returns the options untouched.
 */
export function filterOptionsBySearch(options, query, getLabel = (o) => o) {
  const q = String(query ?? '').trim().toLowerCase();
  if (!q) return options;
  return options.filter((option) =>
    String(getLabel(option) ?? '').toLowerCase().includes(q)
  );
}
